export default __webpack_public_path__ + "static/media/6.ae411394.webp";